import { render, staticRenderFns } from "./SearchResultsTable.vue?vue&type=template&id=1fe359db&scoped=true&"
import script from "./SearchResultsTable.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsTable.vue?vue&type=style&index=0&id=1fe359db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe359db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
